import { request } from "../utils/request";
import { BACKEND_BASE_URL } from "./Resolver";
import { APIResource } from "./Resource";

export class ATPUser extends APIResource {
  baseURL = `${BACKEND_BASE_URL}/api/v1/users`;
  upsertFields = ["username", "role"];

  // Since API returns ID all caps. will be transformed to id.
  ID: string;
  username: string;
  first_name: string;
  last_name: string;
  role: string;
  private readonly initRole: string;

  constructor({
    ID = "",
    username,
    role,
    first_name = "",
    last_name = "",
  }: {
    ID?: string;
    username: string;
    role: string;
    first_name?: string;
    last_name?: string;
  }) {
    super();
    this.ID = ID;
    this.username = username;
    this.role = role;
    this.initRole = role;
    this.first_name = first_name;
    this.last_name = last_name;
  }

  get id(): string {
    return this.ID;
  }

  set id(id: string) {
    this.ID = id;
  }

  hasChangedRole(): boolean {
    return this.role !== this.initRole;
  }

  username__validation(value: string) {
    if (!value) return "Should not be empty.";
    if (!/^\d{9}$/.test(value)) return "Should be 9 char. long and contain only digits.";
  }

  role__validation(value: string) {
    if (!value) return "Should not be empty.";
    if (!["guest", "operator", "admin"].includes(value)) return "Invalid user role";
  }

  // Overwrite parent method since we want to create a record using query string instead body.
  async create(): Promise<void> {
    const url = new URL(`${this.baseURL}`);
    url.searchParams.set("externalID", this.username);
    url.searchParams.set("role", this.role);
    await request(url, { method: "POST" }, true);
  }

  async update(): Promise<void> {
    const url = new URL(`${this.baseURL}/${this.id}`);
    url.searchParams.set("role", this.role);
    await request(url, { method: "PUT" }, true);
  }
}

export class ATPUsers {
  private static baseURL = `${BACKEND_BASE_URL}/api/v1/users`;

  static async list(): Promise<ATPUser[]> {
    const url = new URL(`${this.baseURL}`);
    const response = await request(url, { method: "GET" }, true);
    const json = await response.json();
    return json.users.map((user: ATPUser) => new ATPUser(user));
  }
}
